import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Inrevactiveph from "../../assets/pic/interactive.jpg"
import {Helmet} from "react-helmet";

const Interactive = ()=>{
    return(
        <div className='interactive-wrap'>
            <Helmet>
                <title>رویداد آنلاین تعاملی</title>
                <meta name="description" content="برگزاری رویدادهای آنلاین (مجازی) از آنجایی که محدود به عامل مکان و زمان نیست، مزایای قابل توجهی نظیر کاهش هزینه‌های برگزارکننده و شرکت‌کننده، افزایش تعداد شرکت‌کنندگان و افزایش تعامل بین دارد." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>رویداد ترکیبی تعاملی</h1>
                <img src={Inrevactiveph} alt="رویداد آنلاین تعاملی"/>
                <p>
                    برگزاری رویدادهای آنلاین (مجازی) از آنجایی که محدود به عامل مکان و زمان نیست، مزایای قابل توجهی نظیر کاهش هزینه‌های برگزارکننده و شرکت‌کننده، افزایش تعداد شرکت‌کنندگان و افزایش تعامل بین دارد. در خصوص مزایای رویداد نظیر نمایشگاه آنلاین روی این لینک کلیک کنید.
                </p>
                <p>
                    با همه مزایای قابل توجهی که یک رویداد آنلاین می‌تواند داشته باشد، برخی از افراد به دلیل حس نوستالژیکی که یک رویداد فیزیکی (حضوری) دارد، برگزاری رویدادهای فیزیکی را ترجیح دهند. بدیهی است که جهت موفقیت بیشتر و افزایش تعامل با بازدیدکنندگان، بهتر است تا جامعه آماری خود را بزرگتر کنید.
                </p>
                <p>
                    به همین جهت می‌توانید در کنار برگزاری رویداد فیزیکی خود، محتوای آن رویداد را به صورت آنلاین و همزمان با رویداد فیزیکی با ابزارهای تعاملی استاندارد به اشتراک بگذارید تا طیف بیشتری از بازدیدکنندگان را پوشش دهید.
                </p>
                <p>
                    پلتفرم جامع برگزاری جلسات مجازی BellMeet، تنها پتلفرم بومی و دانش بنیان با کامل‌ترین ابزارهای تعاملی نظیر:
                </p>
                <ul>
                    <li>•	تعامل صوتی با کیفیت بالا</li>
                    <li>•	تعامل تصویری با کیفیت بالا</li>
                    <li>•	گفتگو و تعامل متنی (چت)</li>
                    <li>•	پخش ویدئو آنلاین</li>
                    <li>•	به اشتراک گذاری فایل</li>
                    <li>•	به اشتراک گذاری صفحه نمایش</li>
                    <li>•	و امکان ایجاد نمایش پیام یا اعلانات مهم به صورت دوره‌ای در محیط جلسه</li>
                </ul>
                <p>
                    آماده میزبانی بستر رویداد آنلاین شما است.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default Interactive